import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SelectModule } from 'primeng/select';
import { firstValueFrom } from 'rxjs';
import { notifyAndTrackError } from '../../common/error';
import { AppInsightsService } from '../../services/app-insights.service';
import { ILocation, OrderService } from '../../services/insecta';
import { IPocCatalog } from '../../services/insecta/poc/poc.models';
import { PocService } from '../../services/insecta/poc/poc.service';
import { PocOrderInsectComponent } from './poc-order-insect-item';

@Component({
  selector: 'app-poc-order-details',
  standalone: true,
  imports: [ButtonModule, CommonModule, FloatLabelModule, SelectModule, FormsModule, DialogModule, PocOrderInsectComponent],
  templateUrl: './poc-order-details.component.html'
})
export class PocOrderDetailsComponent {
  private readonly msgService = inject(MessageService);
  private readonly appInsights = inject(AppInsightsService);
  private readonly pocService = inject(PocService);
  private readonly orderService = inject(OrderService);

  sites: any[] = [];
  locations: ILocation[] = [];
  selectedSite: any = null;
  catalog: IPocCatalog | null = null;
  // catalogAddInsect: IPocCatalogAddInsect | null = null;
  // distinctContainers: any[] = [];
  // distinctInsects: any[] = [];
  // distinctGrowthStages: any[] = [];
  // idMaps: any[] = [];
  showInsectModal = false;
  editing: boolean = false;
  editingInstance: boolean = false;
  modalTitle: string = '';
  projectTooltipText: string =
    'Use Project to attribute your order to your research group. The available options are a combination of Biotech projects and Crop Health cost centers.';
  projects: any[] = [];

  ngOnInit(): void {
    firstValueFrom(this.orderService.getLocationsForHierarchy())
      .then((response) => {
        this.locations = response;
        this.sites = this.locations.map((location) => ({
          label: location.name,
          value: location.id
        }));
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'PocOrderDetailsComponent', action: 'InitLoad' });
      });
  }

  getCatalog() {
    firstValueFrom(this.pocService.pocGetCatalog(this.selectedSite))
      .then((response) => {
        this.catalog = response;
        this.projects = response.projects;
        console.log(this.projects);
      })
      .catch((err) => {
        notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'PocOrderDetailsComponent', action: 'GetCatalog:Error' });
      });
  }

  openInsectModal() {
    this.showInsectModal = true;

    // firstValueFrom(this.pocService.pocGetCatalogAddInsect(this.selectedSite))
    //   .then((response) => {
    //     this.catalogAddInsect = response;
    //     console.log('Catalog Add Insect:', this.catalogAddInsect);

    //     // Containers (already present)
    //     this.distinctContainers = [];
    //     if (this.catalogAddInsect?.containerInsectGrowthStages.length > 0) {
    //       const containerMap = new Map<string, { name: string; containerId: string; catalogInsectGrowthStages: any[] }>();
    //       response.containerInsectGrowthStages.forEach((item: any) => {
    //         const containerId = item.containerId;
    //         const name = item.container?.name || '';
    //         if (!containerMap.has(containerId)) {
    //           containerMap.set(containerId, { name, containerId, catalogInsectGrowthStages: [] });
    //         }
    //         containerMap.get(containerId)!.catalogInsectGrowthStages.push({
    //           catalogInsectGrowthStageId: item.catalogInsectGrowthStageId,
    //           infestationRate: item.infestationRate
    //         });
    //       });
    //       this.distinctContainers = Array.from(containerMap.values());
    //       console.log('Distinct containers:', this.distinctContainers);
    //     }

    //     // 1. Distinct insects
    //     this.distinctInsects = [];
    //     const allInsects = response.containerInsectGrowthStages.flatMap((item: any) => {
    //       const catalogInsectId = item.catalogInsectGrowthStage?.catalogInsectId;
    //       const insectObj = item.catalogInsectGrowthStage?.insectGrowthStage?.insect;
    //       const insectId = item.catalogInsectGrowthStage?.insectGrowthStage?.insectId;
    //       if (catalogInsectId && insectId && insectObj) {
    //         return [
    //           {
    //             catalogInsectId,
    //             insectId,
    //             scientificName: insectObj.scientificName,
    //             insectSynonyms: insectObj.insectSynonyms,
    //             insectVariants: insectObj.insectVariants
    //           }
    //         ];
    //       }
    //       return [];
    //     });
    //     // Deduplicate by catalogInsectId
    //     this.distinctInsects = Array.from(new Map(allInsects.map((i) => [i.catalogInsectId, i])).values());
    //     console.log('Distinct insects:', this.distinctInsects);

    //     // 2. Distinct growth stages
    //     const allGrowthStages = response.containerInsectGrowthStages.flatMap((item: any) => {
    //       const insectGrowthStageId = item.catalogInsectGrowthStage?.insectGrowthStageId;
    //       const growthStageId = item.catalogInsectGrowthStage?.insectGrowthStage?.growthStageId;
    //       const growthStageName = item.catalogInsectGrowthStage?.insectGrowthStage?.growthStage?.name || '';
    //       if (insectGrowthStageId && growthStageId) {
    //         return [
    //           {
    //             insectGrowthStageId,
    //             growthStageId,
    //             name: growthStageName
    //           }
    //         ];
    //       }
    //       return [];
    //     });
    //     // Deduplicate by catalogInsectGrowthStageId
    //     this.distinctGrowthStages = Array.from(new Map(allGrowthStages.map((gs) => [gs.insectGrowthStageId, gs])).values());
    //     console.log('Distinct growth stages:', this.distinctGrowthStages);

    //     // Unique mappings of the three IDs (IPocAddInsectIdMap)
    //     this.idMaps = [];
    //     if (this.catalogAddInsect?.containerInsectGrowthStages.length > 0) {
    //       const idMapSet = new Set<string>();
    //       this.idMaps = response.containerInsectGrowthStages.flatMap((item: any) => {
    //         const catalogInsectGrowthStageId = item.catalogInsectGrowthStageId;
    //         const catalogInsectId = item.catalogInsectGrowthStage?.catalogInsectId;
    //         const insectGrowthStageId = item.catalogInsectGrowthStage?.insectGrowthStageId;
    //         if (catalogInsectGrowthStageId && catalogInsectId && insectGrowthStageId) {
    //           const key = catalogInsectGrowthStageId + '|' + catalogInsectId + '|' + insectGrowthStageId;
    //           if (!idMapSet.has(key)) {
    //             idMapSet.add(key);
    //             return [{ catalogInsectGrowthStageId, catalogInsectId, insectGrowthStageId }];
    //           }
    //         }
    //         return [];
    //       });
    //       console.log('Unique ID mappings:', this.idMaps);
    //     }
    //   })
    //   .catch((err) => {
    //     notifyAndTrackError(this.msgService, this.appInsights, err, { component: 'PocOrderDetailsComponent', action: 'OpenInsectModal:Error' });
    //   });
  }

  onDialogCancelInsect() {
    this.showInsectModal = false;
    this.editing = false;
    this.editingInstance = false;
  }
}
